// NPM Imports
import { Toastr } from "@revvsales/components";

// Components Imports
import BaseCommand from "./baseCommand";

// Actions Imports

// services import
import {
  createClauseOptions,
  updateTemplateComponentService,
  updateClauseOptionsService,
} from "../actions/DocumentTemplateActions/templateService";

// Internal Imports

class ImageFieldCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  _getSectionWithClause = (
    id,
    label,
    defaultOption,
    blockType,
    blockID,
    components,
    section,
  ) => {
    let updatedSection = null;
    if (blockType === "COVERPAGE") {
      const coverpageComponent = blockID && components[blockID];
      updatedSection = {
        ...coverpageComponent.content,
        data: {
          ...coverpageComponent.content.data,
          components: {
            ...coverpageComponent.content.data.components,
            [section.id]: {
              ...coverpageComponent.content.data.components[section.id],
              content: {
                ...section,
                clauseOptions: { id, value: defaultOption || null },
              },
            },
          },
        },
      };
    } else if (blockType === "HEADER") {
      const headerComponent = blockID && components[blockID];
      updatedSection = {
        ...headerComponent.content,
        data: {
          ...headerComponent.content.data,
          header: {
            ...headerComponent.content.data.header,
            components: {
              ...headerComponent.content.data.header.components,
              [section.id]: {
                ...headerComponent.content.data.header.components[section.id],
                content: {
                  ...section,
                  clauseOptions: { id, value: defaultOption || null },
                },
              },
            },
          },
        },
      };
    } else if (blockType === "FOOTER") {
      const footerComponent = blockID && components[blockID];
      updatedSection = {
        ...footerComponent.content,
        data: {
          ...footerComponent.content.data,
          footer: {
            ...footerComponent.content.data.footer,
            components: {
              ...footerComponent.content.data.footer.components,
              [section.id]: {
                ...footerComponent.content.data.footer.components[section.id],
                content: {
                  ...section,
                  clauseOptions: { id, value: defaultOption || null },
                },
              },
            },
          },
        },
      };
    } else if (blockType === "BODY") {
      updatedSection = {
        ...section,
        clauseOptions: { id, value: defaultOption || null },
      };
    }

    return updatedSection || section;
  };

  execute() {
    this.command(this.componentData.id, this.componentData.imageField);
  }

  command(id, imageField) {
    const saveClauseOptions = id
      ? updateClauseOptionsService
      : createClauseOptions;

    saveClauseOptions(imageField)
      .then(response => {
        // update section clause with clause id and default value
        const {
          meta: { default: defaultOption },
        } = response;
        const sectionWithClause = this._getSectionWithClause(
          response.id,
          response.label,
          defaultOption,
          this.componentData.blockType,
          this.componentData.blockID,
          this.componentData.components,
          this.componentData.section,
        );
        const fieldIndex = this.componentData.fields
          ? this.componentData.fields.findIndex(field => field.id === id)
          : null;

        this.componentData.addDynamicFieldinListAsync(response, () =>
          updateTemplateComponentService(sectionWithClause).then(() => {
            this.componentData.updateImageFormFieldAndSection(
              response,
              sectionWithClause,
            );
            this.componentData.updateDocumentComponentAction(sectionWithClause);
            this.componentData.toggleDynamicFieldView("LIST");

            if (this.tempImageField) {
              this.componentData.id = null;
              this.componentData.imageField = {
                ...this.componentData.imageField,
                id: null,
              };
            }
            if (!id) {
              this.tempImageField = {
                ...imageField,
                id: response.id,
              };
            }

            Toastr.showToastr({
              type: "success",
              message: `Image form field ${
                fieldIndex > -1 ? "updated" : "created"
              } successfully`,
              timeout: 3000,
            });
          }),
        );
      })
      .catch(error => {
        const { status } = error;
        let message;
        if (status === 409) {
          message = `Couldn't save image form field. Error: Image form field name should be unique.`;
        } else {
          message = `Couldn't save image form field.`;
        }
        Toastr.showToastr({
          type: "failure",
          message: `${message}`,
          timeout: 3000,
        });
      });
  }

  undo() {
    const {
      id,
      section,
      updateComponent,
      oldImageFieldInfo,
    } = this.componentData;
    // Scroll section into view when do Undo/Redo
    if (section) {
      this.scrollIntoView(section.id);
    }
    // ------------- Update case -------------
    if (id) {
      this.command(id, oldImageFieldInfo);
      this.redoable = true;
    }
    // ------------- Delete case -------------
    else {
      const updatedSection = {
        ...section,
        clauseOptions: null,
        form_field: [],
      };
      updateComponent(
        updatedSection,
        undefined,
        false,
        section,
        undefined,
        true,
      );
      this.redoable = true;
      if (this.tempImageField) {
        this.componentData.id = this.tempImageField.id;
        this.componentData.imageField = {
          ...this.componentData.imageField,
          id: this.tempImageField.id,
        };
      }
    }
  }
}

export default ImageFieldCommand;



// WEBPACK FOOTER //
// ./src/commands/imageFieldCommand.js